import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import "./css/Wheel.css";

class Wheel extends Component {

    state = {
        isSpinning: false,
        rotation: 0,
        isConfirmModal: false,
        isResultModal: false,
        isHistoryModal: false,
        isOrdersModal: false,
        result: null,
        history: [],
        historyLoading: false,
        loading: false,
    };

    prizes = [
        { id: 1, name: "۳۰۰ هزار تومان هدیه نقدی", short: "300 هزار تومن", icon: "💵", color: "#9B59B6", color2: "#8E44AD" },
        { id: 2, name: "۲۵ سکه", short: "۲۵ سکه", icon: "🪙", color: "#E74C3C", color2: "#C0392B" },
        { id: 3, name: "۷۵ سکه", short: "۷۵ سکه", icon: "🪙", color: "#F39C12", color2: "#D68910" },
        { id: 4, name: "۵۰ سکه", short: "۵۰ سکه", icon: "🪙", color: "#27AE60", color2: "#1E8449" },
        { id: 5, name: "۱ میلیون تومان هدیه نقدی", short: "۱ میلیون", icon: "💵", color: "#2980B9", color2: "#1F618D" },
        { id: 6, name: "چای‌ساز", short: "چای‌ساز", icon: "🫖", color: "#8E44AD", color2: "#6C3483" },
        { id: 7, name: "جعبه ابزار", short: "جعبه ابزار", icon: "🧰", color: "#C0392B", color2: "#922B21" },
        { id: 8, name: "تی‌شرت", short: "تی‌شرت", icon: "👕", color: "#F39C12", color2: "#B9770E" },
        { id: 9, name: "لباس‌کار", short: "لباس‌کار", icon: "🥼", color: "#27AE60", color2: "#196F3D" },
        { id: 10, name: "۵۰۰ هزار تومان هدیه نقدی", short: "500 هزار تومن", icon: "💵", color: "#2980B9", color2: "#154360" },
    ];

    getSpinHistory = () => {
        const token = localStorage.getItem("token");
        if (token === null) return;

        this.setState({ historyLoading: true });

        const formdata = new FormData();
        formdata.append("token", token);
        const requestOptions = { method: "POST", body: formdata, redirect: "follow" };

        fetch(`${process.env.REACT_APP_BASE_URL}/api/dina-code/get-wheel-history`, requestOptions)
            .then((res) => res.text())
            .then((result) => {
                this.setState({ historyLoading: false });
                if (result !== null) {
                    const myObject = JSON.parse(result);
                    if (myObject.status === 0) {
                        this.setState({ history: myObject.data });
                    }
                }
            })
            .catch((err) => {
                this.setState({ historyLoading: false });
                console.log("getWheelHistory error", err);
            });
    };
    spinWheel = () => {
        this.setState({ isConfirmModal: false, loading: true, isSpinning: true });
        this.props.onSpinWheel((resultData) => {
            if (resultData) {
                this.animateWheel(resultData.prizeIndex, resultData);
            } else {
                this.setState({ isSpinning: false, loading: false });
            }
        });
    };
    animateWheel = (prizeIndex, resultData) => {
        const SLICE_ANGLE = 360 / this.prizes.length;
        const FULL_SPINS = 5;

        const targetAngle =
            FULL_SPINS * 360 +
            (360 - (prizeIndex * SLICE_ANGLE + SLICE_ANGLE / 2)) +
            (360 - (this.state.rotation % 360));

        this.setState({ rotation: this.state.rotation + targetAngle });

        setTimeout(() => {
            this.setState({
                isSpinning: false,
                loading: false,
                isResultModal: true,
                result: resultData,
            });

            // تاریخچه از API گرفته می‌شود، نیازی به saveToHistory نیست
            // چون سرور خودش ثبت کرده
        }, 4200);
    };

    handleShowHistory = () => {
        this.setState({ isHistoryModal: true });
        this.getSpinHistory();
    };
    toggleHistoryModal = () => {
        this.setState({ isHistoryModal: !this.state.isHistoryModal });
    };

    toggleConfirmModal = () => {
        if (!this.props.canSpin || this.state.isSpinning) return;
        this.setState({ isConfirmModal: !this.state.isConfirmModal });
    };
    toggleResultModal = () => {
        this.setState({ isResultModal: !this.state.isResultModal });
    };


    handleShowOrders = () => {
        this.setState({ isOrdersModal: true });
        this.props.onRequestOrders();   // ← API صدا زده می‌شود
    };

    toggleOrdersModal = () => {
        this.setState({ isOrdersModal: !this.state.isOrdersModal });
    };

    // ============ رندر SVG گردونه ============
    /**
     * محاسبه مسیر SVG برای هر قطعه
     */
    getSlicePath = (index) => {
        const totalSlices = this.prizes.length;
        const anglePerSlice = 360 / totalSlices;

        // زاویه شروع و پایان (نسبت به بالای گردونه، ساعت 12)
        const startAngle = index * anglePerSlice - 90;
        const endAngle = (index + 1) * anglePerSlice - 90;

        const startRad = (startAngle * Math.PI) / 180;
        const endRad = (endAngle * Math.PI) / 180;

        const cx = 150;
        const cy = 150;
        const r = 145;

        const x1 = cx + r * Math.cos(startRad);
        const y1 = cy + r * Math.sin(startRad);
        const x2 = cx + r * Math.cos(endRad);
        const y2 = cy + r * Math.sin(endRad);

        const largeArc = anglePerSlice > 180 ? 1 : 0;

        return `M ${cx} ${cy} L ${x1} ${y1} A ${r} ${r} 0 ${largeArc} 1 ${x2} ${y2} Z`;
    };

    getTextPosition = (index) => {
        const totalSlices = this.prizes.length;
        const anglePerSlice = 360 / totalSlices;

        // زاویه وسط قطعه
        const midAngle = index * anglePerSlice + anglePerSlice / 2 - 90;
        const midRad = (midAngle * Math.PI) / 180;

        const cx = 150;
        const cy = 150;
        const r = 100; // فاصله متن از مرکز

        return {
            x: cx + r * Math.cos(midRad),
            y: cy + r * Math.sin(midRad),
            angle: midAngle + 90, // چرخش متن
        };
    };

    render() {
        const { isSpinning, rotation, isConfirmModal, isHistoryModal, isResultModal, result, loading, historyLoading } = this.state;
        const { totalOrders, ordersInCurrentCycle, canSpin, availableChances, bonusChances, orderRewards } = this.props;
        const progress = canSpin
            ? (ordersInCurrentCycle / 50) * 100
            : ((totalOrders % 50) / 50) * 100;


        return (
            <div className="wheel-page body-padding">

                {/* ==== دو باکس بالا ==== */}
                <div className="wheel-top-boxes">

                    {/* باکس تعداد سفارش‌ها */}
                    <div className={`orders-box ${canSpin ? "ready" : ""}`}>
                        <div className="orders-box-icon"><span role="img" aria-label="description">📦</span></div>
                        <div className="orders-box-info">
                            <span className="orders-box-label">امتیاز من</span>
                            <span className="orders-box-value">
                                {totalOrders} <small>/ ۵۰</small>
                            </span>
                            {ordersInCurrentCycle > 0 && (
                                <span className="orders-box-sub">
                                    ({ordersInCurrentCycle} سفارش در دور فعلی)
                                </span>
                            )}

                        </div>
                    </div>
                    <div className={`status-box ${canSpin ? "ready" : "waiting"}`}>
                        <div className="status-box-icon"><span role="img" aria-label="description">
                            {canSpin ? "🎁" : "⏳"}
                        </span>
                        </div>
                        <div className="status-box-info">
                            <span className="status-box-label">وضعیت شانس</span>
                            <span className="status-box-value">
                                {canSpin ? "آماده" : "در انتظار"}
                            </span>
                            {bonusChances > 0 && (
                                <span className="status-box-bonus">
                                    <span role="img" aria-label="description">🎡</span> {bonusChances} فرصت ویژه
                                </span>
                            )}
                        </div>
                    </div>
                </div>
                <div className="progress-wrapper">
                    <div className="progress-bar">
                        <div
                            className="progress-fill"
                            style={{ width: `${Math.min(progress, 100)}%` }}
                        ></div>
                    </div>
                    <p className="progress-text">
                        {canSpin
                            ? `شما ${availableChances} فرصت چرخاندن دارید!`
                            : `${50 - ordersInCurrentCycle} امتیاز دیگر تا دریافت شانس`}
                    </p>
                </div>
                <div className="wheel-header">
                    <h3>گردونه شانس دیناپارت</h3>
                </div>
                <div className="wheel-container">
                    <div className="wheel-pointer">
                        <svg viewBox="0 0 40 50" width="40" height="50">
                            <defs>
                                <linearGradient id="pointerGrad" x1="0%" y1="0%" x2="0%" y2="100%">
                                    <stop offset="0%" stopColor="#FFD700" />
                                    <stop offset="100%" stopColor="#FFA500" />
                                </linearGradient>
                            </defs>
                            <path
                                d="M20 50 L5 22 Q5 5 20 5 Q35 5 35 22 Z"
                                fill="url(#pointerGrad)"
                                stroke="#8B4513"
                                strokeWidth="1.5"
                            />
                            <circle cx="20" cy="18" r="4" fill="#8B4513" opacity="0.4" />
                        </svg>
                    </div>
                    <div className="wheel-lights">
                        {Array.from({ length: 20 }).map((_, i) => (
                            <div
                                key={i}
                                className="wheel-light"
                                style={{
                                    transform: `rotate(${i * 18}deg) translateY(-152px)`,
                                    animationDelay: `${i * 0.1}s`,
                                }}
                            ></div>
                        ))}
                    </div>
                    <svg
                        className={`wheel-svg ${isSpinning ? "spinning" : ""}`}
                        viewBox="0 0 300 300"
                        style={{ transform: `rotate(${rotation}deg)` }}
                    >
                        <defs>
                            {this.prizes.map((prize, i) => (
                                <linearGradient
                                    key={`grad-${i}`}
                                    id={`sliceGrad-${i}`}
                                    x1="0%"
                                    y1="0%"
                                    x2="100%"
                                    y2="100%"
                                >
                                    <stop offset="0%" stopColor={prize.color} />
                                    <stop offset="100%" stopColor={prize.color2} />
                                </linearGradient>
                            ))}
                        </defs>
                        {this.prizes.map((prize, index) => {
                            const path = this.getSlicePath(index);
                            const textPos = this.getTextPosition(index);

                            return (
                                <g key={prize.id}>
                                    <path
                                        d={path}
                                        fill={`url(#sliceGrad-${index})`}
                                        stroke="#FFD700"
                                        strokeWidth="1.5"
                                    />
                                    <text
                                        x={textPos.x}
                                        y={textPos.y - 8}
                                        fontSize="18"
                                        textAnchor="middle"
                                        dominantBaseline="middle"
                                        transform={`rotate(${textPos.angle} ${textPos.x} ${textPos.y})`}
                                    >
                                        {prize.icon}
                                    </text>
                                    <text
                                        x={textPos.x}
                                        y={textPos.y + 10}
                                        fill="#fff"
                                        fontSize="10"
                                        fontWeight="bold"
                                        textAnchor="middle"
                                        dominantBaseline="middle"
                                        transform={`rotate(${textPos.angle} ${textPos.x} ${textPos.y})`}
                                        style={{ textShadow: "0 1px 2px rgba(0,0,0,0.5)" }}
                                    >
                                        {prize.short}
                                    </text>
                                </g>
                            );
                        })}
                        <circle
                            cx="150"
                            cy="150"
                            r="148"
                            fill="none"
                            stroke="#FFD700"
                            strokeWidth="4"
                        />
                        <circle
                            cx="150"
                            cy="150"
                            r="145"
                            fill="none"
                            stroke="#B8860B"
                            strokeWidth="1"
                        />
                        <circle cx="150" cy="150" r="42" fill="#000" />
                        <circle cx="150" cy="150" r="40" fill="#1a1a1a" />
                        <circle cx="150" cy="150" r="35" fill="url(#pointerGrad)" />
                        <circle cx="150" cy="150" r="32" fill="#000" />
                        <text
                            x="150"
                            y="150"
                            fill="#FFD700"
                            fontSize="14"
                            fontWeight="bold"
                            textAnchor="middle"
                            dominantBaseline="middle"
                            onClick={this.toggleConfirmModal}
                        >
                            چرخش
                        </text>
                    </svg>

                </div>
                <div className="wheel-action">
                    <button
                        className={`spin-btn ${canSpin && !isSpinning ? "active" : "disabled"}`}
                        disabled={!canSpin || isSpinning}
                        onClick={this.toggleConfirmModal}
                    >
                        {isSpinning
                            ? "در حال چرخش..."
                            : canSpin
                                ? "🎡 چرخاندن گردونه"
                                : "🔒 قفل - ۵۰ سفارش لازم است"}

                        {/* نشان فرصت‌ها */}
                        {availableChances > 0 && (
                            <span className="spin-chances-badge">
                                {availableChances}
                                {bonusChances > 0 && (
                                    <span className="bonus-badge">+{bonusChances}</span>
                                )}
                            </span>
                        )}
                    </button>

                    <button
                        className="history-btn"
                        onClick={this.handleShowHistory}
                    >
                        <span role="img" aria-label="description">📜</span> مشاهده تاریخچه چرخش‌ها
                        {this.state.history.length > 0 && (
                            <span className="history-badge">{this.state.history.length}</span>
                        )}
                    </button>
                </div>
                {/* ==== Modal تاریخچه ==== */}
                <Modal
                    show={isHistoryModal}
                    onHide={this.toggleHistoryModal}
                    centered
                    size="lg"
                >
                    <Modal.Header closeButton>
                        <Modal.Title><span role="img" aria-label="description">📜</span> تاریخچه چرخش‌های من</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {historyLoading ? (
                            <div className="text-center py-4">
                                <div className="spinner-border text-warning" role="status">
                                    <span className="sr-only">در حال بارگذاری...</span>
                                </div>
                                <p className="mt-2 text-muted small">در حال دریافت تاریخچه...</p>
                            </div>
                        ) : this.state.history.length === 0 ? (
                            <div className="text-center py-4">
                                <div className="empty-icon"><span role="img" aria-label="description">🎡</span></div>
                                <p className="text-muted mb-0">هنوز گردونه‌ای نچرخانده‌اید.</p>
                            </div>
                        ) : (
                            <>
                                <div className="history-summary">
                                    <span>تعداد کل چرخش‌ها:</span>
                                    <strong>{this.state.history.length} بار</strong>
                                </div>

                                <div className="history-list">
                                    {this.state.history.map((entry) => {
                                        const prize = this.prizes[entry.prizeIndex];
                                        const color = prize ? prize.color : "#e97a1a";
                                        const icon = entry.prizeIcon || (prize ? prize.icon : "🏆");

                                        return (
                                            <div
                                                key={entry.id}
                                                className="history-item"
                                                style={{ borderRightColor: color }}
                                            >
                                                <div className="history-icon">{icon}</div>
                                                <div className="history-info">
                                                    <span className="history-prize">
                                                        {entry.prizeName}
                                                    </span>
                                                    <span className="history-date">
                                                        <span role="img" aria-label="description">📅</span> {entry.spunAt}
                                                    </span>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </>
                        )}
                    </Modal.Body>
                    <Modal.Footer className="justify-content-center">
                        <Button
                            className="btn dina-btn-orange"
                            onClick={this.toggleHistoryModal}
                        >
                            بستن
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Modal show={isConfirmModal} onHide={this.toggleConfirmModal} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>تأیید چرخاندن گردونه</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p className="mb-3 text-justify">با تأیید این درخواست، یک فرصت از شانس‌های شما مصرف می‌شود.</p>
                        <div className="confirm-details">
                            <div className="confirm-row">
                                <span>امتیاز فعلی:</span>
                                <strong>{totalOrders}</strong>
                            </div>
                            <div className="confirm-row">
                                <span>فرصت‌های باقیمانده:</span>
                                <strong>{availableChances}</strong>
                            </div>
                            {bonusChances > 0 && (
                                <div className="confirm-row bonus-row">
                                    <span role="img" aria-label="description">🎁 فرصت ویژه وفاداری:</span>
                                    <strong>{bonusChances}</strong>
                                </div>
                            )}
                            <div className="confirm-row highlight">
                                <span>وضعیت:</span>
                                <strong>آماده چرخش</strong>
                            </div>
                        </div>
                        <p className="mt-3 mb-0 text-muted small text-justify">آیا از انجام این عملیات اطمینان دارید؟</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            className="btn btn-sm btn-secondary"
                            onClick={this.toggleConfirmModal}
                        >
                            انصراف
                        </Button>
                        <Button
                            className="btn btn-sm dina-btn-orange"
                            onClick={this.spinWheel}
                            disabled={loading}
                        >
                            {loading ? "در حال ارسال..." : "بچرخان!"}
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Modal
                    show={isResultModal}
                    onHide={this.toggleResultModal}
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title><span role="img" aria-label="description">🎉</span> نتیجه گردونه</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="text-center">
                        {result && (
                            <>
                                <div className="result-icon"><span role="img" aria-label="description">🏆</span></div>
                                <h4 className="result-title">تبریک!</h4>
                                <p className="result-message">
                                    شما برنده‌ی
                                </p>
                                <p className="result-prize">
                                    {result && result.prizeName ? result.prizeName : "-"}
                                </p>
                                <p className="result-message">شدید.</p>

                                <div className="result-note">
                                    نتیجه از طریق پشتیبانی به شما اطلاع داده خواهد شد.
                                </div>
                            </>
                        )}
                    </Modal.Body>
                    <Modal.Footer className="justify-content-center">
                        <Button
                            className="btn dina-btn-orange"
                            onClick={this.toggleResultModal}
                        >
                            متوجه شدم
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Modal
                    show={this.state.isOrdersModal}
                    onHide={this.toggleOrdersModal}
                    centered
                    size="lg"
                >
                    <Modal.Header closeButton>
                        <Modal.Title><span role="img" aria-label="descripton">📦</span> سفارش‌های من</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {orderRewards.length === 0 ? (
                            <p className="text-center text-muted m-0">
                                هنوز سفارشی در این دوره ثبت نکرده‌اید.
                            </p>
                        ) : (
                            <div className="orders-list">
                                {orderRewards.map((item) => (
                                    <div key={item.id} className="order-item">
                                        <div className="order-row">
                                            <span className="order-label"><span role="img" aria-label="description">📅</span> تاریخ:</span>
                                            <span className="order-value">
                                                {item.usedDate}
                                            </span>
                                        </div>
                                        <div className="order-row">
                                            <span className="order-label"><span role="img" aria-label="description">🔢</span> سریال:</span>
                                            <span className="order-value serial">
                                                {item.serialCode}
                                            </span>
                                        </div>
                                        <div className="order-row">
                                            <span className="order-label"><span role="img" aria-label="description">💰</span> مبلغ:</span>
                                            <span className="order-value price">
                                                {item.price.toLocaleString("fa-IR")} ریال
                                            </span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer className="justify-content-center">
                        <Button
                            className="btn dina-btn-orange"
                            onClick={this.toggleOrdersModal}
                        >
                            بستن
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default Wheel;